import React, {useEffect,useState} from 'react';
import { useRouteMatch } from "react-router-dom";
import './discussion-answer.styles.scss';
import { QuestionDiscussion } from "../../@types/question.interface";
import { Dispatch } from "redux";
import { connect } from "react-redux";
import QuestionActionAPI, {
    IFetchQuestionsPayload,
} from "../../redux/question/question.actions";
import { fetchApi } from "../../redux/fetch/fetch.actions";
import DiscussionQuestion from '../../components/discussion-question/discussion-question.component';

interface IProps {
    question: QuestionDiscussion;
    index: number;
}



const DiscussionAnswer = ({question,index}:IProps) => {
    return (
        <div className="take-quiz">
            <div className="take-quiz__detail">
                <div className="take-quiz__detail__header">
                    <div className="take-quiz__detail__header__index">
                        <span className="take-quiz__detail__header__index-title">
                            Question No.
                        </span>
                        <span className="take-quiz__detail__header__index-no">
                            {question?.question_number}
                        </span>
                    </div>
                    <div className="take-quiz__detail__header__countdown">
                    </div>
                </div>
                {/* <ViewQuestion
                    quizId={quizId}
                    question={question}
                    index={index}
                    setIndex={setIndex}
                    questions={questions}
                    length={questions.length}
                    answers={answers}
                    handleChange={handleChange}
                    handleClick={handleClick}
                    takeQuiz
                /> */}
                <DiscussionQuestion question={question} />
            </div>
    </div>
    )
}


export default DiscussionAnswer;